var render = function render(){var _vm=this,_c=_vm._self._c;return _c('underfloor-heating',{staticClass:"w-100",attrs:{"color":_vm.getColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }